import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { UseAgencyMarketingPayload } from '@hooks/useAgencyMarketing'

import { formatEntityCount } from '@functions/entity'

import type { TagModel } from '@models/types'

interface TagListItemProps {
  callbacks: UseAgencyMarketingPayload['callbacks'],
  tag: TagModel,
}

const TagListItem = (props: TagListItemProps) => {
  const { callbacks: { selectTag }, tag } = props

  const { formatted_title, template_pages_count } = tag

  // @ts-expect-error TS2322
  const templatePageCount = formatEntityCount({ entityString: 'Template', entityCount: template_pages_count })

  return (
    <DashboardModuleListItem
      onClick={() => selectTag(tag)}
      // @ts-expect-error TS2322
      showAngleIcon
      title={formatted_title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {templatePageCount}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default TagListItem
